import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { ConditionalWrapper, Icons } from 'msp-components'
import type { SvgSizeType, IconName } from 'msp-integrations'

type ImageLinkProps = {
  icon?: IconName
  iconJasmin?: IconName
  iconSize: SvgSizeType
  manualSize?: string
  image?: string
  imageAlt?: string
  link?: string
  className?: string
  displayType?: string
  colour?: string
  ariaLabel?: string
}

export const ImageLink = ({
  icon,
  iconJasmin,
  iconSize,
  manualSize = '',
  image = '',
  imageAlt = '',
  link = '',
  className = '',
  displayType = 'inline-flex',
  colour = 'black',
  ariaLabel
}: ImageLinkProps) => {
  return (
    <div className={`${displayType} ${className}`}>
      <ConditionalWrapper
        condition={link?.length > 0}
        wrapper={(children: any) => (
          <a href={link} aria-label={ariaLabel}>
            {children}
          </a>
        )}
      >
        {(image && <LazyLoadImage src={image} alt={imageAlt} />) || (
          <Icons
            color={colour}
            height={manualSize}
            size={iconSize}
            iconName={iconJasmin || icon}
          />
        )}
      </ConditionalWrapper>
    </div>
  )
}

export default ImageLink
